import {
  computed,
  defineComponent,
  onMounted,
  nextTick,
  reactive,
  onUnmounted,
  getCurrentInstance,
  defineAsyncComponent,
} from "vue";
import { ref } from "vue";
import { useChatMessageInfo } from "@/store/chatInfo.store";
import { useDebounceFn } from "@vueuse/core";
import { useEnvConfigStore } from "@/store/env.store";
import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/store/globalStore";
import { watch } from "vue";
import { SpanSupportApiServices } from "@/assets/services/spanSupport/apiServices";
import { SpanSupportAuthApiServices } from "@/assets/services/spanSupport/authApiServices";
import { useUserInfo } from "@/store/userInfo.store";
import { useRoute } from "vue-router";
import { uuid } from "vue-uuid";
import { getBrowserDetails, IsNullorWhiteSpace } from "@/utilities/utilities";
import type { UserDetail } from "@/constants/interfaces";
import {
  AIChatLogin,
  GetAIChatBotDetailsById,
} from "@/constants/url-constants";
import { Status, WidgetList } from "@/constants/common-constants";
import { useTheme } from "vuetify";
import { VTour } from "@globalhive/vuejs-tour";
// const Home = defineAsyncComponent(() =>import('@/components/Home/index.vue'))
const News = defineAsyncComponent(() => import("@/components/News/index.vue"));
const Help = defineAsyncComponent(() => import("@/components/Help/index.vue"));
const ChatHistory = defineAsyncComponent(
  () => import("@/components/ChatHistory/index.vue")
);
// const AIChatBot = defineAsyncComponent(() =>import('@/components/AIChatBot/index.vue'))
export default defineComponent({
  name: "ChatOverview",
  components: {
    VTour,
    News,
    Help,
    ChatHistory,
  },
  setup(props, ctx) {
    const BottomActive = ref<Number>(0);
    const isOpenDialog = ref<boolean>(true);
    const chatInfoStore = useChatMessageInfo();
    const isSearching = ref<boolean>(false);
    const componentRef = ref();
    const search = ref<string>("");
    const envConfigStore = useEnvConfigStore();
    const { aiChatBotKeys, envInfo } = storeToRefs(envConfigStore);
    const { ChatCallFrom, ChatNewSessionId, DomSnapBase64Image } =
      storeToRefs(chatInfoStore);
    const {
      IsHideHeadSection,
      ChatCommandCommunication,
      UserDetails,
      AuthenticationDetails,
      CustomMessage,
      IsCustomMessageAnswerReceived,
      HelpArticleId,
      ActiveComponent,
      IsFocusSearch,
      NotificationCount,
      BotIconPath,
      TotalNotificationCount,
      UserMetaDataDetails,
    } = useGlobalStore();
    const spanSupportApiServices = reactive(new SpanSupportApiServices());
    const spanSupportAuthApiServices = reactive(
      new SpanSupportAuthApiServices()
    );
    const userInfoStore = useUserInfo();
    const route = useRoute();
    const { UserLoginInfo } = storeToRefs(userInfoStore);
    let isProgressLoader = ref<boolean>(false);
    const { setAIChatBotConfigKeys } = envConfigStore;
    const theme = useTheme();
    let excludeComponents = ["AIChatBot", "ChatHistory", "Help"];
    const keepAliveComponents = ["Home", "News"];
    const searchinputref = ref<HTMLElement | null>(null);
    const app = getCurrentInstance();
    const chatTour = ref();
    const isBeforeLogin = ref<boolean>(false);
    const { socketConnect, socketClose } = chatInfoStore;
    const eventCustomMessage = ref<Record<string, string>>({});

    // watch(
    //   () => AuthenticationDetails.IsUserAutenticated,
    //   (value) => {
    //     if (value) {
         
    //     }
    //   }
    // );

    watch(ActiveComponent, () => {
      // chatTour.value?.stopTour();
      search.value = "";
      switch (ActiveComponent.value) {
        case WidgetList.Home:
          BottomActive.value = 0;
          break;
        case WidgetList.AIChatBot:
          BottomActive.value = 1;
          //   setTimeout(async() => {
          //     chatTour.value?.startTour();
          // }, 500);
          break;
        case WidgetList.Help:
          BottomActive.value = 2;
          if (IsFocusSearch.value) {
            IsFocusSearch.value = false;
            nextTick(() => {
              searchinputref.value?.focus();
            });
          }
          break;
        case WidgetList.News:
          BottomActive.value = 3;
          break;
        case WidgetList.ChatHistory:
          BottomActive.value = 4;
          break;
      }
    });
    function closeDialog(callFrom: string) {
      search.value = "";
      // if (callFrom == "Close") {
      //   chatInfoStore.ClearChatDetails();
      // }
      // ActiveComponent.value = WidgetList.Home
      ChatCommandCommunication({ command: "MinimizeChat" });
    }

    function changeWidget(data: any = WidgetList.Home) {
      if (ActiveComponent.value != data) {
        ActiveComponent.value = data;
        IsHideHeadSection.value = false;
        ChatCommandCommunication({ command: "MaxmizeChat" });
      }
      switch (data) {
        case WidgetList.AIChatBot:
          ChatCallFrom.value = "NewChat";
          break;
        case WidgetList.Help:
          HelpArticleId.value = "";
          break;
      }
    }

    function navigateToOther(widget: string) {
      ActiveComponent.value = widget;
    }

    function NavigateToHome() {
      ActiveComponent.value = WidgetList.Home;
    }

    const handleSearch = useDebounceFn(() => {
      isSearching.value = true;
      setTimeout(() => {
        isSearching.value = false;
      }, 300);
    }, 300);

    function getChatHistory(callFrom: string = "OldChat") {
      ChatCallFrom.value = callFrom;
      ActiveComponent.value = WidgetList.AIChatBot;
    }

    const backGroundColor = computed(() => {
      return aiChatBotKeys.value?.BackgroundColor || "black";
    });

    onMounted(() => {
      getBrowserDetails();
      ChatNewSessionId.value = uuid.v4();
      if (!IsNullorWhiteSpace(route.query?.UserDetail)) {
        let userDetail: UserDetail = JSON.parse(
          window.atob(route.query?.UserDetail)
        );

        UserDetails.value = userDetail;
        // if (IsNullorWhiteSpace(UserDetails.value.EmailAddress)) {
        //   if (!IsNullorWhiteSpace(UserLoginInfo.value?.EmailAddress)) {
        //     UserDetails.value.EmailAddress = UserLoginInfo.value.EmailAddress;
        //     UserDetails.value.ContactName = UserLoginInfo.value.ContactName;
        //     authenticateUser();
        //   } else {
        //     ActiveComponent.value = WidgetList.UserLogin
        //     setTimeout(() => {
        //       ChatCommandCommunication({ command: "BotReady" });
        //     }, 5000);
        //   }
        // } else {
        //   authenticateUser();
        // }
        if (
          IsNullorWhiteSpace(UserDetails.value.EmailAddress) &&
          !IsNullorWhiteSpace(UserLoginInfo.value?.EmailAddress)
        ) {
          UserDetails.value.EmailAddress = UserLoginInfo.value?.EmailAddress;
        }
        authenticateUser();
      } else {
        ActiveComponent.value = WidgetList.UserLogin;
      }
      listenParentEventMessage();
      // setTimeout(async() => {
      //     chatTour.value?.startTour();
      // }, 1000);
      isBeforeLogin.value =
        UserDetails.value?.ProductKey?.split("-")?.pop()?.toLocaleLowerCase() ==
        "m";
      if (isBeforeLogin.value && !UserDetails.value?.IsHomeSite) {
        chatInfoStore.ClearChatDetails();
      }
    });

    //Listen the parent message
    function listenParentEventMessage() {
      window.addEventListener("message", (event) => {
        let message = event.data;
        let data = JSON.parse(message);
        if (AuthenticationDetails.IsUserAutenticated) {
          if (typeof message == "string") {
            switch (data.type) {
              case "OpenAIChat":
                ActiveComponent.value = WidgetList.AIChatBot;
                break;
              case "OpenHelp":
                ActiveComponent.value = WidgetList.Help;
                openBot();
                break;
              case "OpenHome":
                ActiveComponent.value = WidgetList.Home;
                openBot();
                break;
              case "Base64Image":
                DomSnapBase64Image.value = "";
                setTimeout(() => {
                  DomSnapBase64Image.value = data.message;
                }, 100);
                break;
              case "ClearNotificationCount":
                TotalNotificationCount.value = 0;
                break;
              default:
                break;
            }

            setTimeout(() => {
              TotalNotificationCount.value = 0;
              IsCustomMessageAnswerReceived.value = false;
              CustomMessage.value = data;
              if (data?.type != "OpenHelp") {
                ChatCommandCommunication({ command: "MinimizeChatWidget" });
              }
              if (
                data?.isOpenWidget ||
                data?.type == "OpenHelp" ||
                data?.type == "OpenHome"
              ) {
                openBot();
              }
            }, 100);
          }
        } else if (data.type && data.type != "ClearNotificationCount") {
          eventCustomMessage.value = data;
          ActiveComponent.value = WidgetList.UserLogin;
          // openBot()
        }
      });
    }

    function openBot() {
      openChatBot({ command: "OpenChatBot" });
    }

    // watch(
    //   () => AuthenticationDetails.IsAuthenticateUser,
    //   (value) => {
    //     if (value) {
    //       authenticateUser();
    //     }
    //   }
    // );

    async function authenticateUser() {
      if (!IsNullorWhiteSpace(UserDetails.value)) {
        if (envInfo.value?.ORP.IsEnableORP) {
          initOpenReplay();
        }
        isProgressLoader.value = true;
        const loginRequest = {
          EmailAddress: UserDetails.value?.EmailAddress || UserMetaDataDetails.value?.IpAddress,
          ContactName: UserDetails.value?.ContactName || UserLoginInfo.value.ContactName,
        };

        await spanSupportAuthApiServices
          .postMethod(AIChatLogin, loginRequest)
          .then((res) => {
            if (
              !IsNullorWhiteSpace(res) &&
              res?.OperationStatus == Status.Success
            ) {
              UserLoginInfo.value.JwtToken = res?.JwtToken;
              userInfoStore.SetLoginDetails(res);
              getChatBotKeys();
            } else {
              userInfoStore.Logout();
            }
          })
          .catch((e) => {
            isProgressLoader.value = false;
          });
      }
    }

    function getChatBotKeys() {
      spanSupportApiServices
        .getMethod(GetAIChatBotDetailsById, {
          productKey: UserDetails.value?.ProductKey,
        })
        .then(async (res) => {
          isProgressLoader.value = false;
          if(!IsNullorWhiteSpace(res)){
          AuthenticationDetails.IsUserAutenticated = true;
           setAIChatBotConfigKeys(res);

           if(res.IsLiveAgent){
            initWebSocket()
           }
           if(envInfo.value?.IsOpenChatDefault)
           {
            ActiveComponent.value = WidgetList.AIChatBot
           }
           else if(aiChatBotKeys.value?.IsHome)
            {
             ActiveComponent.value = WidgetList.Home
            }
            else if(aiChatBotKeys.value?.IsChat)
            {
              ActiveComponent.value = WidgetList.AIChatBot
            }
           else if(aiChatBotKeys.value?.IsHelp)
           {
            ActiveComponent.value = WidgetList.Help
           }
           else{
            ActiveComponent.value = WidgetList.UserLogin
           }

           setTimeout(() => {
            ChatCommandCommunication({ command: "BotReady" });
          }, 500);
        
        theme.themes.value.ChatCustomTheme.colors.primary = res?.PrimaryColor
         theme.themes.value.ChatCustomTheme.colors.secondary = res?.SecondaryColor 
         theme.themes.value.ChatCustomTheme.colors.tertiary = res?.BackgroundColor 
         BotIconPath.value = res?.BotIconPath
         if(Object.keys(eventCustomMessage.value).length !=0)
         {
          openBotAfterAuthenticate()
         }
        }
        })
        .catch((e) => {});
    }

    function initOpenReplay() {
      const openReplayScript = document.createElement("script");
      openReplayScript.type = "text/javascript";
      openReplayScript.async = true;
      var key = envInfo.value?.ORP.Key;
      var ingestPoint = envInfo.value?.ORP.IngestPoint;
      // defaultInputMode
      // 2 means = Do not record any input fields
      // 1 means = Do not record any obsecure input fields
      // 0 means = Record all input fields
      const emailAddress =
        UserDetails.value?.EmailAddress || UserMetaDataDetails.value?.IpAddress;
      openReplayScript.innerHTML = `var initOpts = {
  projectKey: "${key}",
  ingestPoint: "${ingestPoint}",
  __DISABLE_SECURE_MODE: ${
    envInfo.value?.Environment == "local" ? true : false
  },
  defaultInputMode: 0,
  obscureTextNumbers: false,
  obscureTextEmails: false,
  network: { // Enable HTTP payload capture in the network option
  capturePayload: true,
  failuresOnly: true,
  useProxy: true
} 
};
var startOpts = {userID: "${emailAddress}"};
 (function(A,s,a,y,e,r){
  r=window.OpenReplay=[e,r,y,[s-1, e]];
  s=document.createElement('script');s.src=A;s.async=!a;
  document.getElementsByTagName('head')[0].appendChild(s);
  r.start=function(v){r.push([0])};
  r.stop=function(v){r.push([1])};
  r.setUserID=function(id){r.push([2,id])};
  r.setUserAnonymousID=function(id){r.push([3,id])};
  r.setMetadata=function(k,v){r.push([4,k,v])};
  r.event=function(k,p,i){r.push([5,k,p,i])};
  r.issue=function(k,p){r.push([6,k,p])};
  r.isActive=function(){return false};
  r.getSessionToken=function(){};
})("//static.openreplay.com/14.0.7/${
        envInfo.value?.ORP.IsEnableAssist ? "openreplay-assist" : "openreplay"
      }.js", 1, 0, initOpts, startOpts);`;
      document.head.appendChild(openReplayScript);
    }

    //Open Chat Bot
    function openChatBot(command: Object) {
      ChatCommandCommunication(command);
    }

    function initWebSocket() {
      socketConnect({
        url: aiChatBotKeys.value?.WebSocketUrl,
        reconnectAttempts: 5,
        reconnectTimeout: 3000,
      });
    }

    onUnmounted(() => {
      socketClose();
    });

    const overallTourSteps = [
      {
        target: "#home",
        placement: "top",
        highlight: true,
        content: `Start your journey here! Just click to get instant help with any tax questions`,
      },
      {
        target: "#aiChatBot",
        placement: "top",
        highlight: true,
        content: `Need human help? Switch between our smart AI and our friendly support team right here!`,
      },
      {
        target: "#help",
        placement: "top",
        highlight: true,
        content:
          "Browse through our help articles or search for specific topics in the Help section.",
      },
      {
        target: "#chatHistory",
        placement: "top",
        highlight: true,
        content: "View your latest chat history.",
      },
    ];

    const chatTourSteps = [
      {
        target: "#aiid",
        content:
          "Meet our AI assistant - available 24/7 for instant answers to all your tax questions!",
      },
      {
        target: "#liveagent",
        content:
          "Need specialized help? Connect with our tax experts for personalized support.",
      },
    ];

    const tourSteps = computed(() =>
      ActiveComponent.value == WidgetList.AIChatBot
        ? chatTourSteps
        : overallTourSteps
    );
    const tourName = computed(() =>
      ActiveComponent.value == WidgetList.AIChatBot ? "chat" : "overall"
    );

    function openBotAfterAuthenticate() {
      let widget = "";
      switch (eventCustomMessage.value.type) {
        case "OpenAIChat":
          widget = WidgetList.AIChatBot;
          break;
        case "OpenHelp":
          widget = WidgetList.Help;
          openBot();
          break;
        case "OpenHome":
          widget = WidgetList.Home;
          openBot();
          break;
        default:
          break;
      }
      setTimeout(() => {
        if (eventCustomMessage.value.type) {
          ActiveComponent.value = widget;
        }
        CustomMessage.value = eventCustomMessage.value;
        eventCustomMessage.value = {};
      }, 1000);
    }


    function continueChat(){
      authenticateUser()
    }

    return {
      isOpenDialog,
      closeDialog,
      ActiveComponent,
      changeWidget,
      navigateToOther,
      NavigateToHome,
      handleSearch,
      isSearching,
      componentRef,
      search,
      aiChatBotKeys,
      getChatHistory,
      backGroundColor,
      IsHideHeadSection,
      isProgressLoader,
      BottomActive,
      excludeComponents,
      keepAliveComponents,
      searchinputref,
      NotificationCount,
      tourSteps,
      chatTourSteps,
      chatTour,
      tourName,
      isBeforeLogin,
      UserDetails,
      IsNullorWhiteSpace,
      continueChat
    };
  },
});
